import { createApp, ref } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import helper from "@/utils/helper";
import VueSweetalert2 from "vue-sweetalert2";
import VueApexCharts from "vue3-apexcharts";

import "sweetalert2/dist/sweetalert2.min.css";
import "./assets/index.css";
import "./registerServiceWorker";
import fcmToken from "./utils/fcm";

const app = createApp(App);
// We use this in axios interceptor to set loading status
app.config.globalProperties.$loading = ref(false);

fcmToken().then((token) => console.log(token));

app
  .use(store)
  .use(router)
  .use(helper)
  .use(VueSweetalert2)
  .use(VueApexCharts)
  .mount("#app");

window.Apex.chart = { fontFamily: "iransans" };

export default app;
